// crete job use case will take the application state objects and use them to create an entity from them, then dependign on the use case some application logic can be doen this with entitiy and finally it is sent to the repopsitory method to create the Job
// internally the repository will map the entity to a DTO and be transfered to the backenc

import type { IJobRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import { CreateJob, Job } from "@domain/schemas/BI";

@injectable()
export class CreateJobService {
  @inject(TYPES.IJobRepository)
  private _jobRepository!: IJobRepository;

  async createJobAsync(formState: CreateJob): Promise<Job> {
    return this._jobRepository.createAsync(formState);
  }
}
